import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Node, NodeChange } from '@xyflow/react';

export function FN_GRAPH_UPDATE__node_position__by_change(change: NodeChange<Node>, graph: DTO_GRAPH__instance) {
  if (change.type !== 'position') return false;
  if (!change.position) return false;

  const node_id = change.id;

  // Initial target coordinates in grid units
  const start_x = Math.round(change.position.x);
  const start_y = Math.round(change.position.y);

  const node = graph.node__get(node_id);
  const [w, h] = [node.meta.graph_width_px, node.meta.graph_height_px];
  const other_nodes = graph.nodes__get_all().filter(n => n.meta.node_id !== node_id);

  // Helper function to check if a specific grid coordinate is blocked
  const isOverlap = (tx: number, ty: number) => {
    return other_nodes.some(other => {
      const [ox, oy] = [other.meta.graph_x_px, other.meta.graph_y_px];
      const [ow, oh] = [other.meta.graph_width_px, other.meta.graph_height_px];
      return tx < ox + ow && tx + w > ox && ty < oy + oh && ty + h > oy;
    });
  };

  // BFS / Spiral Search for the nearest valid (x, y)
  let final_x = start_x;
  let final_y = start_y;

  if (isOverlap(start_x, start_y)) {
    let found = false;
    // Search in increasing "layers" or shells outward from the center
    for (let radius = 1; radius < 20; radius++) {
      for (let dx = -radius; dx <= radius; dx++) {
        for (let dy = -radius; dy <= radius; dy++) {
          // We only check the perimeter of the current radius
          // to mimic a spiral/expanding square
          if (Math.abs(dx) === radius || Math.abs(dy) === radius) {
            if (!isOverlap(start_x + dx, start_y + dy)) {
              final_x = start_x + dx;
              final_y = start_y + dy;
              found = true;
              break;
            }
          }
        }
        if (found) break;
      }
      if (found) break;
    }
  }

  if (change.dragging === false) {
    node.meta.graph_x_px = final_x;
    node.meta.graph_y_px = final_y;
    change.position.x = final_x;
    change.position.y = final_y;
    return true;
  }

  change.position.x = final_x;
  change.position.y = final_y;

  return false;
}
